import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { formatHour } from '../../lib/format';

/**
 * Edit Open Play session dialog: adjust start/end hour, max players, price.
 * Extracted from OperatorToday.
 */
export default function EditOpenPlayDialog({
  open,
  onOpenChange,
  hours,
  startHour,
  endHour,
  maxPlayers,
  price,
  onStartHourChange,
  onEndHourChange,
  onMaxPlayersChange,
  onPriceChange,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="edit-open-play-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-lg">Edit Open Play Session</DialogTitle>
        </DialogHeader>
        <div className="space-y-5 py-2">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm font-medium text-text-secondary">Start Hour</Label>
              <Select value={startHour} onValueChange={onStartHourChange}>
                <SelectTrigger className="rounded-xl mt-1.5 border-border-subtle" data-testid="edit-op-start">
                  <SelectValue placeholder="Start" />
                </SelectTrigger>
                <SelectContent>
                  {hours.map(h => (
                    <SelectItem key={h} value={String(h)}>{formatHour(h)}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-sm font-medium text-text-secondary">End Hour</Label>
              <Select value={endHour} onValueChange={onEndHourChange}>
                <SelectTrigger className="rounded-xl mt-1.5 border-border-subtle" data-testid="edit-op-end">
                  <SelectValue placeholder="End" />
                </SelectTrigger>
                <SelectContent>
                  {hours.filter(h => {
                    const start = parseInt(startHour);
                    return isNaN(start) || h >= start;
                  }).map(h => (
                    <SelectItem key={h} value={String(h + 1)}>{formatHour(h)}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm font-medium text-text-secondary">Max Players</Label>
              <Input
                data-testid="edit-op-max"
                value={maxPlayers}
                onChange={(e) => onMaxPlayersChange(e.target.value)}
                type="number"
                className="rounded-xl mt-1.5 border-border-subtle focus:border-open-play"
              />
            </div>
            <div>
              <Label className="text-sm font-medium text-text-secondary">Price per Player (₱)</Label>
              <Input
                data-testid="edit-op-price"
                value={price}
                onChange={(e) => onPriceChange(e.target.value)}
                type="number"
                className="rounded-xl mt-1.5 border-border-subtle focus:border-open-play"
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl border-border-subtle">
            Cancel
          </Button>
          <Button
            data-testid="edit-op-submit-btn"
            onClick={onSubmit}
            className="bg-open-play hover:bg-open-play/90 text-white rounded-xl px-8"
          >
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
